var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.banners.length)?_c('div',{staticClass:"banners"},_vm._l((_vm.banners),function(bannerType,index){return _c('Banner',{key:index,attrs:{"src":_vm.src,"type":bannerType},on:{"click":function($event){return _vm.emitBannerAction(_vm.banner)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }